import { type CountryValue, getStateShortCodes } from "@offstreetparking/geography";

export const getStateOptions = (country?: CountryValue) => {
	if (country === "Canada" || country === "United States of America") {
		return { US: getStateShortCodes("US"), CA: getStateShortCodes("CA"), MX: getStateShortCodes("MX") };
	}
	if (country === "United Kingdom") {
		return { GB: getStateShortCodes("GB") };
	}

	return {};
};
